import React, { FC } from 'react';
import * as Styled from './styled';

interface IIllustrationProps {
  name: string;
  alt: string;
  height?: number;
  width?: number;
  spacingBottom?: number;
  spacingTop?: number;
}

const Illustration: FC<IIllustrationProps> = (props) => <Styled.StyledIllustration {...props} />;

Illustration.defaultProps = {
  height: null,
  width: null,
  spacingBottom: null,
  spacingTop: null,
};

export { Illustration };
